import React, {memo} from 'react';

import "./style.scss"

export const GridContainer = ({children}) => (
    <div className="grid-container">{children}</div>
)

export default memo(GridContainer)